

























































































































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_reportGeneralInvoiceStats_currentUnit_generalInvoiceStatistics, GQL_reportGeneralInvoiceStats } from '@/queries/__generated__/reportGeneralInvoiceStats';
import range from 'lodash/range';
import padStart from 'lodash/padStart';
import formatAmount from '@/filters/formatAmount';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';

const REPORT_GENERAL_INVOICE_STATS = gql`
  query reportGeneralInvoiceStats(
    $from: String!,
    $to: String!,
    $interval: ReportIntervalEnum,
    $fields: [String!]!,
  ) {
    currentUnit {
      id
      generalInvoiceStatistics(
        from: $from,
        to: $to,
        interval: $interval,
        fields: $fields,
      ) {
        period
        totalIncludingTax
        totalExcludingTax
        numberOfInvoices
      }
    }
  }
`;

@Component
export default class GeneralInvoiceStatistics extends Vue {
  @SmartQuery<GeneralInvoiceStatistics, GQL_reportGeneralInvoiceStats>({
    query: REPORT_GENERAL_INVOICE_STATS,
    fetchPolicy: 'no-cache',
    variables() {
      return {
        from: this.$dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM'),
        to: this.$dayjs().endOf('year').format('YYYY-MM'),
        fields: [
          'number_of_invoices',
          'total_excluding_tax',
          'total_including_tax',
        ],
        interval: 'MONTHLY',
      };
    },
    update(data) {
      const currentYear = this.$dayjs().year();
      const currentMonth = this.$dayjs().month() + 1;
      const lastYear = currentYear - 1;

      const allMonths = [
        ...range(1, 13).map(m => `${lastYear}-${padStart(String(m), 2, '0')}`),
        ...range(1, currentMonth + 1).map(m => `${currentYear}-${padStart(String(m), 2, '0')}`),
      ];

      const filledEntries: GQL_reportGeneralInvoiceStats_currentUnit_generalInvoiceStatistics[] = [];

      allMonths.forEach(m => {
        const entry = data.currentUnit.generalInvoiceStatistics.find(e => e.period === m);
        filledEntries.push(entry || {
          __typename: 'ReportGeneralInvoiceStatistic',
          period: m,
          totalIncludingTax: new Decimal(0),
          totalExcludingTax: new Decimal(0),
          numberOfInvoices: 0,
        });
      });

      return filledEntries;
    },
  }) private generalInvoiceStatistics!: GQL_reportGeneralInvoiceStats_currentUnit_generalInvoiceStatistics[];

  private formatAmount = formatAmount;
  private showTable = false;

  private wholeNumber(val: number): string {
    return val % 1 === 0 ? String(val) : '';
  }
}
